module.exports = __webpack_public_path__ + "img/ag4.1be6d272.png";